import z from "zod";

import { slugify } from "@/utils/strings";

import { FlagCategory, FlagPriority } from "../constants/flags";

export const PracticeFlagFormSchema = z.object({
  /**
   * The persisted flag code is `slugify(name)`, and `slugify` drops everything outside `[a-z0-9-]`.
   * A name with no ASCII alphanumerics — a non-Latin script, or "???" — would otherwise slugify to
   * an empty string and persist a `Coding` with no code. Reject it at the boundary instead.
   */
  name: z
    .string()
    .trim()
    .min(1, "Flag name is required")
    // Zod collects both issues on a dirty value, so an empty name would otherwise surface this
    // message instead of the `min` one. Defer to `min` for the blank case.
    .refine(
      (name) => name.length === 0 || slugify(name).length > 0,
      "Flag name must contain letters or numbers",
    ),
  category: z.nativeEnum(FlagCategory).nullable(),
  priority: z.nativeEnum(FlagPriority).nullable(),
  description: z.string().trim(),
});

export type PracticeFlagFormType = z.infer<typeof PracticeFlagFormSchema>;

/** Category and priority open unselected, matching the design's "Select" placeholders. */
export const PRACTICE_FLAG_INITIAL_VALUES: PracticeFlagFormType = {
  name: "",
  category: null,
  priority: null,
  description: "",
};
